import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const EmptyRoleList = () => {
  return (
    <>
      <Box paddingTop="s24" textAlign="center" flexDirection="column" gap="s8">
        <Box alignItems={'center'}>
          <Icon.Large icon="user-interaction-review_chart" />
        </Box>
        <Text weight="medium" size="300" color="grey1000">
          {i18n.t('project_management.settings.sections.project_roles.empty_list.title')}
        </Text>
        <Text weight="normal" size="300" color="grey800">
          {i18n.t('project_management.settings.sections.project_roles.empty_list.description')}
        </Text>
      </Box>
    </>
  )
}

export default EmptyRoleList
